import styled from "styled-components";
import { useRecoilState } from "recoil";
import { accountName, bookmarkList, repoList, searchRepoList } from "../store";
import { color } from "../style/theme";
import { Link } from "react-router-dom";

const Header = () => {
	const [account, setAccount] = useRecoilState(accountName);
	const [repo, setRepo] = useRecoilState(repoList);
	const [bookmark, setBookmark] = useRecoilState(bookmarkList);
	const [search, setSearch] = useRecoilState(searchRepoList);

	const resetHandler = () => {
		setAccount("");
		setRepo([]);
		setBookmark([]);
		setSearch([]);
	};

	return (
		<HeaderSection>
			<Link to="/">
				<span className="point">&#123;</span>
				<span className="dot">...</span>
				<span className="point">&#125;</span>
			</Link>

			<NavSection>
				<Link to="/issues">issues page</Link>

				<div onClick={() => resetHandler()} className="accountBox">
					{account === "" ? "등록된 계정이 없습니다" : account.toUpperCase()}
					<img src="/images/clear.png" alt="clear" />
				</div>
			</NavSection>
		</HeaderSection>
	);
};

const HeaderSection = styled.header`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 1rem 3rem;
	position: fixed;
	width: 100vw;
	box-sizing: border-box;
	background: ${color.black};

	.dot {
		font-size: 4rem;
		font-weight: bold;
	}

	.point {
		color: ${color.subPoint};
		font-size: 3rem;
		margin: 0;
		padding: 0;
		font-weight: bold;
	}
`;

const NavSection = styled.nav`
	display: flex;
	align-items: center;

	.accountBox {
		border: 3px solid ${color.subPoint};
		border-radius: 18px;
		padding: 0.5rem 3rem;
		color: ${color.subPoint};
		font-weight: bold;
		cursor: pointer;
		transition: all 0.2s ease 0s;
		position: relative;

		img {
			display: none;
			width: 18px;
			position: absolute;
			right: 15px;
		}

		&:hover {
			border: 3px solid ${color.point};

			img {
				display: inline;
			}
		}
	}

	a {
		background: ${color.point};
		padding: 0.8rem 1.5rem;
		border-radius: 13px;
		transition: all 0.3s ease 0s;
		box-shadow: 0px 2px 20px #943403;
		margin-right: 3rem;

		&:hover {
			transform: translateY(-2px);
			box-shadow: 0px 2px 30px #943403;
		}
	}
`;

export default Header;
